/**
 * Stable NOVA cache keys. This dependency-free module is safe to use
 * from cache projection code without initializing server-function imports.
 */
export const novaHomeQueryKeys = {
  deliverableState: ["nova", "home", "deliverable-state"] as const,
  retiredWork: ["nova", "home", "retired-work"] as const,
  retiredNotes: ["nova", "retired-notes"] as const,
  /** Her NOVA routines and every read keyed below them (the weekly check-in). */
  routines: ["nova", "routines"] as const,
  /** My assets and every asset page, keyed below it (`novaAssetsQuery`). */
  assets: ["nova-assets"] as const,
};
